"use client";

import { useTranslations } from "next-intl";
import { AlertCircle } from "lucide-react";

interface CancellationPolicyProps {
  policy?: string;
}

export default function CancellationPolicy({
  policy,
}: CancellationPolicyProps) {
  const t = useTranslations("product.cancellation");

  return (
    <div className="py-6">
      <h2 className="text-lg sm:text-xl font-semibold mb-4">{t("title")}</h2>

      {/* Warning Notice */}
      <div className="flex items-start gap-2 bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-5">
        <AlertCircle className="h-5 w-5 text-yellow-600 shrink-0 mt-0.5" />
        <p className="text-sm text-yellow-800">{t("warning")}</p>
      </div>

      {/* Policy Content */}
      {policy ? (
        <div className="text-sm sm:text-base text-gray-600 whitespace-pre-line wrap-break-word">
          {policy}
        </div>
      ) : (
        <p className="text-sm sm:text-base text-gray-600">
          {t("defaultPolicy")}
        </p>
      )}
    </div>
  );
}
